import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as momentTimeZone from 'moment-timezone';


@Component({
  selector: 'app-invoice-details',
  standalone: false,
  templateUrl: './invoice-details.component.html',
  styleUrl: './invoice-details.component.scss'
})
export class InvoiceDetailsComponent {
constructor(
    public dialogRef: MatDialogRef<InvoiceDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  payInvoice() {
    // Emit or handle pay invoice logic
    this.dialogRef.close({ action: 'pay', invoice: this.data });
  }

    checkDaylight(etaDate) {
      if (momentTimeZone.tz(etaDate, 'America/New_York').isDST()) return 'EDT';
      else return 'EST';
    }
}
